import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// Icons

import { ReactComponent as CancelledIcon } from './assets/icons/cancelled.svg';
import { ReactComponent as CreatedIcon } from './assets/icons/created.svg';
import { ReactComponent as InOverstayIcon } from './assets/icons/in_overstay.svg';
import { ReactComponent as InProgressIcon } from './assets/icons/in_progress.svg';
import { ReactComponent as StartedIcon } from './assets/icons/started.svg';
import { ReactComponent as FinishedIcon } from './assets/icons/finished.svg';

import styles from './style.cssmodule.css';

function Status({ status }) {
  const { formatMessage: t } = useIntl();
  let Icon = null;
  let label = null;

  switch (status) {
    case 'STARTED':
      label = t({ id: 'onDemand.status.started' });
      Icon = <StartedIcon />;
      break;
    case 'CREATED':
      label = t({ id: 'onDemand.status.created' });
      Icon = <CreatedIcon />;
      break;
    case 'IN_PROGRESS':
      label = t({ id: 'onDemand.status.inProgress' });
      Icon = <InProgressIcon />;
      break;
    case 'IN_OVERSTAY':
      label = t({ id: 'onDemand.status.inOverstay' });
      Icon = <InOverstayIcon />;
      break;
    case 'FINISHED':
      label = t({ id: 'onDemand.status.finished' });
      Icon = <FinishedIcon />;
      break;
    case 'CANCELLED':
      label = t({ id: 'onDemand.status.cancelled' });
      Icon = <CancelledIcon className={styles.icon} />;
      break;
    default:
      label = t({ id: 'onDemand.status.allStatuses' });
      Icon = null;
  }

  return (
    <div className={styles.container} data-status={status}>
      {Icon && <div className={styles.iconContainer}>{Icon}</div>}
      <span className={`${styles.label} label`}>{label}</span>
    </div>
  );
}

Status.propTypes = {
  status: PropTypes.string,
};

Status.defaultProps = {
  status: null,
};

export default Status;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Status/Status.jsx